import { render, staticRenderFns } from "./servicForm.vue?vue&type=template&id=120b57ac&"
import script from "./servicForm.vue?vue&type=script&lang=js&"
export * from "./servicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports